/** Month calendar with markers for days that have data. */
import { useState, type ReactElement } from 'react';
import { formatMonth } from '../lib/dates';
import { Icon } from './Icon';

const DOW: readonly string[] = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

export function Calendar({ value, today, marked, onPick }: { value: string; today: string; marked: ReadonlySet<string>; onPick: (day: string) => void }): ReactElement {
  const [y0, m0] = value.split('-').map(Number) as [number, number];
  const [view, setView] = useState<{ y: number; m: number }>({ y: y0, m: m0 - 1 });
  const first: Date = new Date(Date.UTC(view.y, view.m, 1));
  const startOffset: number = first.getUTCDay();
  const cells: Array<{ day: string; other: boolean; n: number }> = [];
  for (let i = 0; i < 42; i++) {
    const d: Date = new Date(Date.UTC(view.y, view.m, 1 - startOffset + i));
    cells.push({ day: d.toISOString().slice(0, 10), other: d.getUTCMonth() !== view.m, n: d.getUTCDate() });
  }
  const shift = (delta: number): void => {
    const d: Date = new Date(Date.UTC(view.y, view.m + delta, 1));
    setView({ y: d.getUTCFullYear(), m: d.getUTCMonth() });
  };
  return (
    <div className="cal">
      <div className="cal-head">
        <button type="button" className="icon-btn" onClick={() => shift(-1)} aria-label="Previous month"><Icon name="chevL" size={16} /></button>
        <span>{formatMonth(view.y, view.m)}</span>
        <button type="button" className="icon-btn" onClick={() => shift(1)} aria-label="Next month"><Icon name="chevR" size={16} /></button>
      </div>
      <div className="cal-grid">
        {DOW.map((d, i) => <div key={i} className="cal-dow">{d}</div>)}
        {cells.map((c) => (
          <button key={c.day} type="button" onClick={() => onPick(c.day)}
            className={`cal-day ${c.other ? 'other' : ''} ${c.day === today ? 'today' : ''} ${c.day === value ? 'sel' : ''}`}>
            {c.n}{marked.has(c.day) && <span className="mk" />}
          </button>
        ))}
      </div>
      <div style={{ marginTop: 10, textAlign: 'center' }}>
        <button type="button" className="btn btn-sm" onClick={() => onPick(today)}>Jump to today</button>
      </div>
    </div>
  );
}

